import { Link } from 'react-router-dom';
import { usePortal } from '../../contexts/PortalContext';
import { REPORT_MODULE_CATEGORIES, reportModulesByCategory } from '../../lib/reportModules';

export function ReportsHomePage() {
  const { basePath } = usePortal();

  return (
    <div className="forms-home-page">
      <h1 className="forms-home-page__title">Report</h1>

      <div className="forms-home-page__categories">
        {REPORT_MODULE_CATEGORIES.map((category) => {
          const modules = reportModulesByCategory(category.id);
          if (modules.length === 0) return null;
          return (
            <section key={category.id} className="forms-home-page__category">
              <h2 className="forms-home-page__category-title">{category.label}</h2>
              <div className="forms-home-page__grid">
                {modules.map((mod) => (
                  <Link
                    key={mod.slug}
                    to={basePath ? `${basePath}/${mod.slug}` : `/${mod.slug}`}
                    className="forms-home-page__card"
                  >
                    <span className="forms-home-page__icon" aria-hidden>
                      {mod.icon}
                    </span>
                    <span className="forms-home-page__card-title">{mod.title}</span>
                  </Link>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}
